let _zhuye = {
	"name": "主页",
	"mdi": "el-icon-s-home",
	"href": "/sys/index"
}
// -------------组织机构管理--------------------------------
let _zhjg = {
	"name": "组织机构管理",
	"mdi": "el-icon-school",
	"href": "",
	"list": []
}

let _school = {
	"name": "学校管理",
	"href": "/sys/org/school"
}

let _dept = {
	"name": "学院管理",
	"href": "/sys/org/dept"
}

let _major = {
	"name": "专业管理",
	"href": "/sys/org/major"
}

let _class = {
	"name": "班级管理",
	"href": "/sys/org/class"
}
// -------------用户管理------------------------
let _yhgl = {
	"name": "用户管理",
	"mdi": "el-icon-s-custom",
	"href": "",
	"list": []
}

let _schoolUser = {
	"name": "校级管理员",
	"href": "/sys/user/school"
}

let _deptUser = {
	"name": "院级管理员",
	"href": "/sys/user/dept"
}

let _teacherUser = {
	"name": "教师管理",
	"href": "/sys/user/teacher"
}

let _studentUser = {
	"name": "学生管理",
	"href": "/sys/user/student"
}
// --------------产品管理----------------------------
let _cpgl = {
	"name": "产品管理",
	"mdi": "el-icon-s-grid",
	"href": "",
	"list": []
}

let _productCategory = {
	"name": "产品分类管理",
	"href": "/sys/product/category"
}

let _product = {
	"name": "产品管理",
	"href": "/sys/product/product"
}

let _productModelCategory = {
	"name": "产品模块分类管理",
	"href": "/sys/product/modelcategory"
}

let _productModel = {
	"name": "产品模块管理",
	"href": "/sys/product/model"
}
// ------------产品资源管理---------------------------------
let _zygl = {
	"name": "产品资源管理",
	"mdi": "el-icon-s-grid",
	"href": "",
	"list": []
}

let _resourceType = {
	"name": "资源分类管理",
	"href": "/sys/productResource/type"
}
let _resource = {
	"name": "资源管理",
	"href": "/sys/productResource/resource"
}
// --------------个人资源库-------------------------
let _grzyk = {
	"name": "个人资源库",
	"mdi": "el-icon-s-grid",
	"href": "",
	"list": [{
		"name": "资源管理",
		"href": "/sys/userResource/resourceKu"
	}]
}

// --------------题库管理-------------------------
let _tkgl = {
	"name": "题库管理",
	"mdi": "el-icon-notebook-2",
	"href": "",
	"list": [{
			"name": "题库管理",
			"href": "/sys/questions/bank"
		},
		{
			"name": "题型管理",
			"href": "/sys/questions/questionType"
		},
		{
			"name": "理论试题管理",
			"href": "/sys/questions/questions"
		},
		{
			"name": "仿真试题管理",
			"href": "/sys/questions/simQuestions"
		}
	]
}
// ------------课程管理-------------------------------
let _kcgl = {
	"name": "课程管理",
	"mdi": "el-icon-s-management",
	"href": "",
	"list": []
}

let _course = {
	"name": "课程管理",
	"href": "/sys/course/home"
}

let _courseExam = {
	"name": "考核管理",
	"href": "/sys/course/exampaper"
}
// ------------统计分析-------------------------------
let _tjfx = {
	"name": "统计分析",
	"mdi": "el-icon-s-data",
	"href": "",
	"list": []
}

//开放角色：校级管理员  、院系管理员教师，可以查询数据
let _analysis_userLoginLog = {
	"name": "登录信息统计",
	"href": "/sys/analysis/userLoginLog"
}


// 教师统计分析
let _analysis_teacher_course_class_statistics = {
	"name": "班级数据统计",
	"href": "/sys/analysis/teacher_course_class_statistics"
}

let _analysis_teacher_course_users_statistics = {
	"name": "学生数据统计",
	"href": "/sys/analysis/teacher_course_users_statistics"
}

let _analysis_teacher_course_experiments_users_statistics = {
	"name": "学生实验练习进度",
	"href": "/sys/analysis/teacher_course_experiments_users_statistics"
}

let _analysis_teacher_course_resource_users_statistics = {
	"name": "学生资源学习进度",
	"href": "/sys/analysis/teacher_course_resource_users_statistics"
}

let _simExpAnalysis = {
	"name": '仿真实验数据分析',
	'href': '/sys/analysis/simExpAnalysis'
}

let _userLoginLog_Analysis = {
	"name": '用户访问信息统计',
	"href": '/sys/analysis/userLoginLog_Analysis'
}

// ------------老年人能力评估-------------------------------
let _lnr = {
	"name": "老年人能力评估管理",
	"mdi": "el-icon-s-data",
	"href": "",
	"list": [{
			"name": "量表分类管理",
			"href": "/sys/nna/tableType"
		}, {
			"name": "量表管理",
			"href": "/sys/nna/table"
		}, {
			"name": "考核评估案例管理",
			"href": "/sys/nna/case"
		},
		{
			"name": "考核评估记录查询",
			"href": "/sys/nna/caseLog"
		},
		{
			"name": "基础评估查询",
			"href": "/sys/nna/archivesLog"
		},
		{
			"name": "基础评估报告查询",
			"href": "/sys/nna/reportLog"
		}
	]
}
// ------------护理需求评估-------------------------------
let _nna = {
	"name": "护理需求评估管理",
	"mdi": "el-icon-s-data",
	"href": "",
	"list": [{
			"name": "量表分类管理",
			"href": "/sys/nna/tableType"
		}, {
			"name": "量表管理",
			"href": "/sys/nna/table"
		}, {
			"name": "实训管理",
			"href": "/sys/nna/training"
		}, {
			"name": "考试管理",
			"href": "/sys/nna/exam"
		}, {
			"name": "综合实训案例管理",
			"href": "/sys/nna/case"
		},
		{
			"name": "综合实训记录查询",
			"href": "/sys/nna/caseLog"
		},
		{
			"name": "评估工具查询",
			"href": "/sys/nna/archivesLog"
		},
		{
			"name": "评估工具报告查询",
			"href": "/sys/nna/reportLog"
		}
	]
}
// ------------虚拟养老院-------------------------------
let _vnh = {
	"name": "虚拟养老院",
	"mdi": "el-icon-s-data",
	"href": "",
	"list": []
}
let vnh_post = {
	"name": "岗位管理",
	"href": "/sys/vnh/post"
}

let vnh_medal = {
	"name": "奖章管理",
	"href": "/sys/vnh/medal"
}
let vnh_taskType = {
	"name": "任务类型",
	"href": "/sys/vnh/taskType"
}
let vnh_task = {
	"name": "任务管理",
	"href": "/sys/vnh/task"
}
let vnh_ranking = {
	"name": "排行榜",
	"href": '/sys/vnh/ranking'
}
// ------------交互式课件-------------------------------
let _jhskjgl = {
	"name": "赛训技能视听课件管理",
	"mdi": "el-icon-s-data",
	"href": "",
	"list": [{
		"name": "课件管理",
		"href": "/sys/jhskj"
	}]
}
// ------------赛训过程评价管理-------------------------------
let _sxgcpjgl = {
	"name": "赛训过程评价管理",
	"mdi": "el-icon-s-data",
	"href": "",
	"list": [{
		"name": "摄像机管理",
		"href": "/sys/sxpj/camera"
	},{
		"name": "训练分类管理",
		"href": "/sys/sxpj/category"
	}, {
		"name": "训练技能管理",
		"href": "/sys/sxpj/table"
	}, {
		"name": "学习情况统计",
		"href": "/sys/sxpj/analysis"
	}]
}

// ------------神经系统临床思维支持系统-------------------------------
let _nct = {
	"name": "神经系统临床思维支持系统",
	"mdi": "el-icon-s-data",
	"href": "",
	"list": [{
		"name": "案例管理",
		"href": "/sys/nct/case"
	}]
}


// ------------反馈信息-------------------------------
let _feedback = {
	"name": "问题反馈",
	"mdi": "el-icon-s-data",
	"href": "",
	"list": [{
		"name": "反馈处理",
		"href": "/sys/feedback"
	}]
}


export default {
	loadMenu(roleID, config, productList) {
		let menu = []
		_zhjg.list = []
		_yhgl.list = []
		_cpgl.list = []
		_kcgl.list = []
		_tjfx.list = []
		_zygl.list = []
		_vnh.list = []
		//默认添加主页
		menu.push(_zhuye)

		// 组织架构-角色
		switch (roleID) {
			case 1:
				_zhjg.list.push(_school)
			case 2:
				_zhjg.list.push(_dept)
			case 3:
				_zhjg.list.push(_major)
			case 4:
				_zhjg.list.push(_class)
				break;
			default:
		}

		menu.push(_zhjg)

		// 用户管理
		switch (roleID) {
			case 1:
				_yhgl.list.push(_schoolUser)
			case 2:
				_yhgl.list.push(_deptUser)
			case 3:
				_yhgl.list.push(_teacherUser)
			case 4:
				_yhgl.list.push(_studentUser)
				break;
			default:
		}
		menu.push(_yhgl)

		//产品管理
		if (roleID == 1) {
			_cpgl.list.push(_productCategory)
			_cpgl.list.push(_product)
			_cpgl.list.push(_productModelCategory)
			_cpgl.list.push(_productModel)
			menu.push(_cpgl)
		}

		// 产品资源管理
		_zygl.list.push(_resourceType)
		_zygl.list.push(_resource)
		menu.push(_zygl)

		// 个人资源库
		menu.push(_grzyk)

		//题库管理
		if (config.closeSimQuestion) {
			_tkgl.list.splice(3, 1);
		}
		menu.push(_tkgl)

		// 课程管理
		_kcgl.list.push(_course)
		// _kcgl.list.push(_courseExam)
		menu.push(_kcgl)
		// ------------------------子软件---------------------------
		
		//护理需求评估 | 老年人能力评估
		if (productList.indexOf('d6be4509-f75d-87c5-f6fd-14d9c8345d91') > -1) {
			if (config.assessmentType) {
				if (config.assessmentType == '2') {
					menu.push(_lnr)
				} else {
					menu.push(_nna)
				}
			}
		}

		// 虚拟养老院
		if (productList.indexOf('554909a2-acc3-47a0-5bca-c72cb7c23764') > -1) {
			switch (roleID) {
				case 1:
				case 2:
					_vnh.list.push(vnh_post)
					_vnh.list.push(vnh_medal)
					_vnh.list.push(vnh_taskType)
				case 4:
					_vnh.list.push(vnh_task)
					break;
				default:
			}
			_vnh.list.push(vnh_ranking)
			menu.push(_vnh)
		}

		// 交互式课件
		if (productList.indexOf('9c7a8697-7e9e-2bbc-753e-6455ebc28170') > -1) {
			menu.push(_jhskjgl)
		}

		//赛训过程性评价系统
		if (productList.indexOf('bda22de8-bc1e-687b-d46b-27d5d70bddd0') > -1) {
			menu.push(_sxgcpjgl)
		}

		//神经系统临床思维支持系统
		if (productList.indexOf('fcb03c46-33ed-f49c-d555-f3130321c8ff') > -1) {
			menu.push(_nct)
		}


		// ---------------------------------------------------
		//统计分析
		if (roleID == 4) {
			// 教师
			_tjfx.list.push(_analysis_teacher_course_class_statistics)
			_tjfx.list.push(_analysis_teacher_course_users_statistics)
			_tjfx.list.push(_analysis_teacher_course_experiments_users_statistics)
			_tjfx.list.push(_analysis_teacher_course_resource_users_statistics)
		}

		_tjfx.list.push(_simExpAnalysis)
		_tjfx.list.push(_analysis_userLoginLog)
		// _tjfx.list.push(_userLoginLog_Analysis)
		menu.push(_tjfx)

		if (roleID == 1) {
			menu.push(_feedback)
		}
		return menu
	}
}